import { Injectable, isDevMode } from '@angular/core';

const KEY = 'authToken';

@Injectable({ providedIn: 'root' })
export class TokenService {
  //storage = isDevMode() ? window.localStorage : window.sessionStorage;
  storage = window.localStorage;

  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    this.storage.setItem(KEY, token);
  }

  getToken() {
    return this.storage.getItem(KEY);
  }

  removeToken() {
    this.storage.removeItem(KEY);
  }
}
